module.exports = __webpack_public_path__ + "img/help.5f98b018.svg";